export enum DatasheetFieldComponentTextAlign {
  left = 1,
  center = 2,
  right = 3,
}